import { Link } from "../../molecules/Link";

export const ProgramaSidebar = (props) => {
  return (
    <nav
      id={"sidebar"}
      className={"flex flex-col min-w-[13rem] min-h-screen bg-theme-blue text-white"}
    >
      <Link route={"/programas"}>{"Lista de programas"} </Link>
      <Link route={"/programas/registrar"}>{"Agregar programa"} </Link>
      <Link route={"/programas/gestionar-idiomas"}>{"Gestionar idiomas"} </Link>
    </nav>
  );
};
